import { useStockApi } from "../api/StockApiClient";
import { StockFrontendService } from "../services/StockFrontendService";

export const useStockService = (): StockFrontendService =>
  new StockFrontendService(useStockApi());
